import { IppicaScommesseEsitoResultsRenderer } from '../../ippicaScommesseEsito/ippicaScommesseEsitoResultsRenderer';
import { IppicaScommesseTableRowUiContainer } from '../ippicaScommesseTableRowUiContainer';
export type IppicaScommesseTableRowResultProps = {
  keyCavallo: string;
};

export const IppicaScommesseTableRowResult = ({ keyCavallo }: IppicaScommesseTableRowResultProps) => {
  return (
    <IppicaScommesseTableRowUiContainer keyCavallo={keyCavallo}>
      <IppicaScommesseEsitoResultsRenderer keyCavallo={keyCavallo} />
    </IppicaScommesseTableRowUiContainer>
  );
};
